<template>
    <with-dimensions>
        <table-ish slot-scope="{ width }">
            <table-ish-row-header>
                <table-ish-cell>
                    Tenants
                </table-ish-cell>

                <table-ish-cell
                    :shrink="true"
                    class="text-right"
                >
                    Balance
                </table-ish-cell>

                <table-ish-cell
                    v-if="width > 500"
                    :shrink="true"
                    class="text-right"
                >
                    Term
                </table-ish-cell>
            </table-ish-row-header>

            <table-ish-row-router-link
                v-for="tenancy in tenancies"
                :key="tenancy.uuid"
                :to="{
                    name: $router.fix('dashboard.*.tenancies.show'),
                    params: {
                        tenancy: tenancy.uuid
                    }
                }"
            >
                <table-ish-cell>
                    <slot
                        name="primary"
                        :tenancy="tenancy"
                    />

                    <template slot="secondary">
                        <slot
                            name="secondary"
                            :tenancy="tenancy"
                        />
                    </template>
                </table-ish-cell>

                <table-ish-cell
                    :shrink="true"
                    :class="{ 'line-through': !!tenancy.terminated_at }"
                    class="text-right"
                >
                    {{ tenancy.balance | money }}

                    <template slot="secondary">{{ tenancy.amount | money(0) }} / mo</template>
                </table-ish-cell>

                <table-ish-cell
                    v-if="width > 500"
                    :shrink="true"
                    :class="{ 'line-through': !!tenancy.terminated_at }"
                    class="text-right"
                >
                    <base-tenancy-period :tenancy="tenancy" />

                    <template slot="secondary">{{ $_.upperFirst(tenancy.term) }} term, {{ tenancy.is_rolling ? 'rolling' : 'non-rolling' }}</template>
                </table-ish-cell>
            </table-ish-row-router-link>
        </table-ish>
    </with-dimensions>
</template>

<script>
    import _ from 'lodash'
    import BaseTenancyPeriod from './base-tenancy-period'

    export default {
        components: {
            BaseTenancyPeriod
        },
        props: {
            tenancies: {
                type: Array,
                required: true
            }
        },
        methods: {
            tenantNames (tenants) {
                if (_.isEmpty(tenants.data)) {
                    return 'No tenants'
                }
                return _.chain(tenants.data)
                    .map(tenant => {
                        return tenant.name
                    })
                    .join(', ')
                    .truncate({
                        length: 50,
                        separator: /,? +/
                    })
                    .value()
            }
        }
    }
</script>
